import React, { useContext, useEffect } from "react";
import { NavLink } from "react-router-dom";
import sidebarMenu from "./sidebarMenu";
import { AuthContext } from "./AuthContext";

const Sidebar = ({ sidebarToggled, toggleSidebar }) => {
  const { role } = useContext(AuthContext);
  const handleSubmenuClick = () => {
    // Only proceed if we're on a small screen or sidebar toggled on large screen
    if (
      window.innerWidth < 768 ||
      (window.innerWidth > 768 && sidebarToggled)
    ) {
      // Close all open submenu collapses
      document.querySelectorAll(".collapse.show").forEach((el) => {
        el.classList.remove("show");

        // Also add 'collapsed' class back to its trigger
        const trigger = document.querySelector(
          `[data-toggle="collapse"][href="#${el.id}"], [data-toggle="collapse"][data-target="#${el.id}"]`
        );
        if (trigger) {
          trigger.classList.add("collapsed");
          trigger.setAttribute("aria-expanded", "false");
        }
      });

      // Collapse the entire sidebar (body and #accordionSidebar)
      toggleSidebar(); // Make sure this correctly updates your sidebar state
    }
  };

  useEffect(() => {
    console.log(role);
  }, []);

  return (
    <ul
      className={`navbar-nav bg-gradient-purples sidebar sidebar-dark accordion ${
        sidebarToggled ? "toggled" : ""
      }`}
      id="accordionSidebar"
    >
      {/* Brand */}
      <NavLink
        className="sidebar-brand d-flex align-items-center justify-content-start"
        to="/home"
      >
        <div className="sidebar-brand-icon">
          <div className="logo-wrapper">
            <img
              src={`${process.env.PUBLIC_URL}/img/logo_gwel.png`}
              width={40}
              alt="logo"
            />
          </div>
        </div>
        <div className="sidebar-brand-text mx-1">
          <span></span>
        </div>
      </NavLink>

      {sidebarMenu
        .filter((item) => {
          // If the item has a 'roles' array, only include if current role is in it
          if (item.roles && Array.isArray(item.roles)) {
            return item.roles.includes(role);
          }
          return true; // no 'roles' means visible to all
        })
        .map((item, index) => {
          if (item.heading) {
            return (
              <div className="sidebar-heading" key={index}>
                {item.heading}
              </div>
            );
          }

          if (item.children) {
            const collapseId = `collapse${index}`;

            // Filter children by role as well
            const filteredChildren = item.children.filter((child) => {
              if (child.roles && Array.isArray(child.roles)) {
                return child.roles.includes(role);
              }
              return true;
            });

            if (filteredChildren.length === 0) return null; // hide parent if no children visible

            return (
              <li className="nav-item" key={index}>
                <a
                  className="nav-link collapsed"
                  href="#"
                  data-toggle="collapse"
                  data-target={`#${collapseId}`}
                  aria-expanded="false"
                  aria-controls={collapseId}
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </a>
                <div
                  id={collapseId}
                  className="collapse"
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    {filteredChildren.map((child, cIdx) => (
                      <NavLink
                        key={cIdx}
                        className="collapse-item"
                        to={child.href}
                        onClick={handleSubmenuClick}
                      >
                        <i className={child.icon}></i> {child.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
              </li>
            );
          }

          if (item.external) {
            return (
              <li className="nav-item" key={index}>
                <a
                  className="nav-link"
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </a>
              </li>
            );
          }

          return (
            <li className="nav-item" key={index}>
              <NavLink className="nav-link" to={item.href} end>
                <i className={item.icon}></i>
                <span>{item.label}</span>
              </NavLink>
            </li>
          );
        })}

      <div className="text-center d-none d-md-inline mt-auto">
        <button
          className="rounded-circle border-0"
          id="sidebarToggle"
          onClick={toggleSidebar}
        />
      </div>
    </ul>
  );
};

export default Sidebar;
